module.exports = __webpack_public_path__ + "/images/cover-hucha-inicio.EN.c3cf201.png";